export interface Vertical {
  id: string;
  code: string;
  name: string;
  fullName: string;
  tagline: string;
  description: string;
  icon: string;
  color: string;
  services: string[];
  benefits: string[];
  faqs: { q: string; a: string }[];
  phone: string;
  website?: string;
}

export const verticals: Vertical[] = [
  {
    id: 'bms', code: 'RMSL', name: 'Med In Scans & Labs', fullName: 'Reach Med In Scans & Labs',
    tagline: 'Trusted Diagnostics. Complete Care.',
    description: 'Advanced diagnostic imaging, pathology, and preventive health services delivering accurate results with trusted expertise.',
    icon: '🔬', color: '#005B66',
    services: ['MRI Scanning', 'CT Scanning', 'X-Ray & Ultrasound', 'Blood & Urine Tests', 'ECG & Echo', 'Full Body Checkup Packages', 'Pathology Lab', 'Home Sample Collection'],
    benefits: ['NABL-accredited processes', 'Results within 4–6 hours', 'Home sample pickup', 'Digital reports via WhatsApp', 'Affordable packages', 'Expert radiologists on call'],
    faqs: [
      { q: 'Do you offer home sample collection?', a: 'Yes, we offer home sample collection across Pallavaram, Chromepet and Tambaram.' },
      { q: 'How soon will I get my reports?', a: 'Routine blood tests are delivered within 4–6 hours. MRI and CT reports within 24 hours.' },
      { q: "Do I need a doctor's prescription?", a: 'For most tests, a prescription is recommended but not mandatory.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'rmc', code: 'RMC', name: 'Reach Multispeciality Clinics', fullName: 'Reach Multispeciality Clinics',
    tagline: 'One Reach. Endless Care.',
    description: 'A network of multispeciality clinics delivering patient-centric care across multiple disciplines.',
    icon: '🏥', color: '#0B7078',
    services: ['General Medicine', 'Paediatrics', 'Gynaecology', 'Orthopaedics', 'Dermatology', 'ENT', 'Cardiology Consultation', 'Diabetology'],
    benefits: ['Panel of 20+ specialists', 'Same-day appointments', 'Integrated with diagnostics', 'Child-friendly environment', 'Senior citizen priority queue', 'Cashless insurance accepted'],
    faqs: [
      { q: 'Can I book an appointment online?', a: 'Yes, you can book via WhatsApp or phone.' },
      { q: 'Do you have paediatric specialists?', a: 'Yes, our experienced paediatricians are available 6 days a week.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'rhms', code: 'RHMS', name: 'Reach Home Medcare Services', fullName: 'Reach Home Medcare Services',
    tagline: 'Professional Care, At Your Doorstep.',
    description: 'Bringing hospital-quality care to your home with trained nursing staff and medical professionals.',
    icon: '🏠', color: '#005B66',
    services: ['Home Nursing', 'Post-surgical Care', 'Physiotherapy at Home', 'IV Drip Administration', 'Wound Dressing', 'Caretaker Services', 'Elder Care Support', 'Doctor Home Visits'],
    benefits: ['24/7 availability', 'Trained & certified nurses', 'Elder care specialists', 'Affordable packages', 'Background-verified staff', 'Regular updates to family'],
    faqs: [
      { q: 'How quickly can you deploy a nurse?', a: 'For emergency requests, within 4–6 hours. Planned requests within 24 hours.' },
      { q: 'Are your nursing staff certified?', a: 'All nursing staff are B.Sc Nursing or GNM certified with background verification.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'rp', code: 'RP', name: 'Reach Pharma', fullName: 'Reach Pharma',
    tagline: 'Your Health. Our Priority.',
    description: 'A full-service pharmacy offering prescription medicines, OTC products, health supplements and medical consumables.',
    icon: '💊', color: '#D62828',
    services: ['Prescription Medicines', 'OTC Products', 'Generic Medicines', 'Health Supplements', 'Surgical Consumables', 'Home Medicine Delivery', 'Chronic Medication Management', 'Diabetic & Cardiac Care Products'],
    benefits: ['Genuine medicines only', 'Generic alternatives available', 'Home delivery across Chennai', 'Integrated with Reach Clinics', 'Expert pharmacist consultation', 'Competitive pricing'],
    faqs: [
      { q: 'Do you deliver medicines at home?', a: 'Yes, we deliver across Pallavaram, Chromepet, Tambaram within the same day.' },
      { q: 'Do you stock generic medicines?', a: 'Yes, we maintain a comprehensive range of quality generic alternatives.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
      {
    id: 'rsl', code: 'RSL', name: 'Reach Scans and Labs', fullName: 'Reach Scans and Labs',
    tagline: 'Accurate Diagnostics. Reliable Results.',
    description: 'A leading diagnostic center offering a wide range of medical tests with state-of-the-art equipment.',
    icon: '🧪', color: '#1E90FF',
    services: ['Blood Tests', 'Imaging Services', 'Health Check-ups', 'Specialized Diagnostics', 'Home Sample Collection'],
    benefits: ['Accurate results', 'Quick turnaround time', 'Experienced technicians', 'Advanced equipment', 'Convenient locations'],
    faqs: [
      { q: 'What is the minimum age for enrolment?', a: 'We accept students from age 6 upwards with different programmes for each age group.' },
      { q: 'Do you provide sports injury rehabilitation?', a: 'Yes, our sports medicine team handles injury assessment and return-to-play protocols.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'rsp', code: 'RSP', name: 'Reach Surgicals & Pharma', fullName: 'Reach Surgicals & Pharmaceuticals',
    tagline: 'Precision Supplies for Precision Care.',
    description: 'A trusted supplier of surgical instruments, medical equipment and pharmaceutical products to healthcare institutions.',
    icon: '⚕️', color: '#005B66',
    services: ['Surgical Instruments', 'Hospital Furniture & Equipment', 'Diagnostic Equipment Supply', 'Medical Consumables', 'Orthopaedic Implants', 'ICU & OT Equipment', 'Sterilisation Products', 'B2B Institutional Supply'],
    benefits: ['ISO-certified products', 'Competitive institutional pricing', 'Fast delivery logistics', 'After-sales support', 'Wide product catalogue', 'Bulk order discounts'],
    faqs: [
      { q: 'Do you supply to private clinics?', a: 'Yes, we supply to hospitals, nursing homes and private clinics.' },
      { q: 'What is the minimum order for bulk supplies?', a: 'Minimum order quantities vary by product. Contact us for a customised quote.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'academy', code: 'Academy', name: 'Reach Academy', fullName: 'Reach Academy',
    tagline: 'Learn Bold. Achieve More.',
    description: 'Empowering future healthcare professionals through industry-focused education, hands-on practical training, and modern laboratory learning.',
    icon: '🎓', color: '#0B7078',
    services: ['GNM Nursing Training', 'Paramedical Courses', 'Medical Lab Technology', 'Pharmacy Assistant Certification', 'Home Nursing Training', 'First Aid & CPR Certification', 'CME Programmes', 'Hospital Management Courses'],
    benefits: ['Government-affiliated curriculum', 'Placement assistance', 'Hands-on clinical training', 'Flexible batch timings', 'Experienced faculty', 'Affordable fees'],
    faqs: [
      { q: 'What courses do you offer?', a: 'Paramedical, nursing assistant, lab technician, pharmacy assistant and hospital management courses.' },
      { q: 'Is placement assistance provided?', a: 'Yes, we have a dedicated placement cell with tie-ups across Reach Group verticals.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'impex', code: 'IMPEX', name: 'Reach Impex', fullName: 'Reach Impex',
    tagline: 'One Reach. Trusted Needs.',
    description: 'Connecting global markets with trusted sourcing and seamless international trade solutions.',
    icon: '🌐', color: '#005B66',
    services: ['Medical Device Import', 'Diagnostic Equipment Export', 'Regulatory Compliance Consulting', 'Custom Clearance Support', 'International Procurement', 'Product Certification Assistance', 'OEM Partnerships', 'Healthcare Trade Consulting'],
    benefits: ['CDSCO-compliant imports', 'Global sourcing network', 'Regulatory expertise', 'End-to-end logistics', 'Competitive pricing', 'Trusted international partnerships'],
    faqs: [
      { q: 'Do you help with regulatory approvals?', a: 'Yes, we provide full support for CDSCO registration and import licenses.' },
      { q: 'Can you source specific equipment on request?', a: 'Yes, we specialise in custom procurement from our global network.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'gardens', code: 'Gardens', name: 'Reach Gardens', fullName: 'Reach Gardens',
    tagline: 'Rooted in Nature. Committed to Care.',
    description: 'A wellness-focused vertical integrating natural healing, therapeutic gardens and nature-based health programmes.',
    icon: '🌿', color: '#0B7078',
    services: ['Herbal Garden Therapy', 'Wellness Retreats', 'Naturopathy Consultations', 'Meditation & Mindfulness Sessions', 'Organic Product Supply', 'Agricultural Health Programmes', 'Corporate Wellness Events', 'Therapeutic Horticulture'],
    benefits: ['Science-backed natural therapies', 'Certified wellness practitioners', 'Peaceful healing environment', 'Personalised wellness plans', 'Complements medical treatment', 'Group and individual sessions'],
    faqs: [
      { q: 'Is this suitable for people undergoing medical treatment?', a: 'Yes, our programmes complement conventional medical treatment under expert supervision.' },
      { q: 'Do you offer corporate wellness programmes?', a: 'Yes, we offer customised corporate wellness packages including on-site events.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },
  {
    id: 'rsa', code: 'RSA', name: 'Reach Sports Academy', fullName: 'Reach Sports Academy',
    tagline: 'Play Bold. Dream Big. Reach Higher.',
    description: 'A modern sports academy combining elite athletic coaching with sports medicine for all age groups.',
    icon: '⚽', color: '#D62828',
    services: ['Football Coaching', 'Cricket Academy', 'Athletics & Track Training', 'Sports Medicine & Physio', 'Fitness & Conditioning', 'Nutrition Counselling for Athletes', 'Youth Sports Development', 'Talent Identification Programmes'],
    benefits: ['Qualified national coaches', 'Sports medicine support', 'Modern training infrastructure', 'Age-group batches', 'Scholarship opportunities', 'Regular tournaments & exposure'],
    faqs: [
      { q: 'What is the minimum age for enrolment?', a: 'We accept students from age 6 upwards with different programmes for each age group.' },
      { q: 'Do you provide sports injury rehabilitation?', a: 'Yes, our sports medicine team handles injury assessment and return-to-play protocols.' },
    ],
    phone: '+91 9XXXXXXXXX',
  },

];